export const SERVER = 'https://port-0-typequest-server-20zynm2mljxnfret.sel4.cloudtype.app';
